export default {
  getLatestCourses({state, commit}) {
    if (state.latestCoursesFetchStatus) return state.latestCourses

    return new Promise((resolve, reject) => {
      axios.get('/api/v1/credential/courses?latest&limit=8')
          .then(({data}) => {
            commit('SET_COURSES_LATEST', data);
            commit('SET_LATEST_COURSES_FETCH_STATUS', 'all');
            resolve(state.latestCourses);
          })
          .catch(({response}) => reject(response))
    })
  },

  getPopularCourses({state, commit}) {
    if (state.popularCoursesFetchStatus) return state.popularCourses

    return new Promise((resolve, reject) => {
      axios.get('/api/v1/credential/courses?popular&limit=8')
          .then(({data}) => {
            commit('SET_POPULAR_COURSES', data);
            commit('SET_POPULAR_COURSES_FETCH_STATUS', 'all');
            resolve(state.popularCourses);
          })
          .catch(({response}) => reject(response))
    })
  }
}
